import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/topics', label: '求证专区' },
  { to: '/archive', label: '辟谣档案' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const BrandTag = isHome ? 'h1' : 'div';
  const brandContent = (
    <Link to="/" className="group flex items-center gap-3" aria-label="瓜田求证社首页">
      <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
        <i className="ri-search-eye-line text-xl"></i>
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">瓜田求证社</span>
        <span className="mt-0.5 font-label text-[11px] tracking-[0.2em] text-foreground-600">QUIZHENG LAB</span>
      </span>
    </Link>
  );

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled || !isHome
          ? 'border-background-200 bg-background-50/90 backdrop-blur-md'
          : 'border-transparent bg-background-50/60 backdrop-blur-sm'
      }`}
    >
      <div className="flex w-full items-center justify-between px-4 py-3 md:px-8">
        <BrandTag className="m-0">{brandContent}</BrandTag>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-4 py-2 font-label text-sm transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex">
          <Link
            to="/about#contact"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            <i className="ri-send-plane-line"></i>
            提交线索
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {open ? (
        <div className="animate-fade-in border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `rounded-md px-4 py-3 font-label text-sm transition-colors ${
                    isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/about#contact"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-md bg-foreground-950 px-4 py-3 font-label text-sm font-medium text-background-50"
            >
              <i className="ri-send-plane-line"></i>
              提交线索
            </Link>
          </nav>
        </div>
      ) : null}
    </header>
  );
}